// extracted by mini-css-extract-plugin
export default {"checkboxes":"questionDrawer_checkboxes__8GiBi"};